import request from "./config";

export default class RequirementsService {
  static create(data) {
    return request({
      url: "/requirements",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/requirements/${id}`,
      method: "patch",
      data,
    });
  }
  static changeStatus(id,data) {
    return request({
      url: `/requirements/change-status/${id}`,
      method: "patch",
      data,
    });
  }
  
  static delete(id) {
    return request({
      url: `/requirements/${id}`,
      method: "delete",
    });
  }
  static  find(params) {
    return request({
      url: `/requirements`,
      method: "get",
      params:params
    });
  }
}
